module.exports = __webpack_public_path__ + "img/icircle.fe2c5ef1.svg";